export const weeklyModuleOptions = [
  {
    label: "Weekly Performance Notification",
    value: "Weekly Performance Notification",
  },
];
